import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.SET_ARTICLE_DATA:
      return state.withMutations((previousState) => {
        previousState
          .set('data', fromJS(action.payload.data))
          .set('processing', action.payload.processing)
      })
    case actions.RESET_ARTICLE_DATA:
      return initialState
    case actions.SET_ARTICLE_PROCESSING:
      return state.withMutations((previousState) => {
        previousState.set('processing', action.payload)
      })
    case actions.SET_ARTICLE_ID:
      return state.withMutations((previousState) => {
        previousState
          .set('id', action.payload.id)
          .set('processing', action.payload.processing)
      })
    case actions.SET_ARTICLE_EMAIL_CAPTURE_COOKIE:
      return state.withMutations((previousState) => {
        previousState.set('emailCaptureCookie', action.payload)
      })
    default:
      return state
  }
}
